let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8vJE0")).then(() => parcelRequire('aARrG'));